import VPagination from './VPagination'

export default {
  VPagination
}



// WEBPACK FOOTER //
// ./src/components/pagination/index.js